import './MissingModule.scss';
import Module from "core/ts/system/Module";

export default class MissingModule extends Module {
}
